import React, { useEffect } from 'react';
import { Typography } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import TVPanelCard from './TVPanelCard';
import { getStoreContentVideoDetails } from '../../redux/dashboard/actionCreator';

const { Text, Title } = Typography;

const TVPanelBlock = () => {
    const dispatch = useDispatch();
    const storeContentVideoDetailsData = useSelector(state => state.storeContentVideoDetailsData);

    useEffect(() => {
        dispatch(getStoreContentVideoDetails());
    }, [dispatch]);

    return (
        <div
            style={{
                minHeight: '100vh',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: '#f8fafc',
                padding: 24,
            }}
        >
            <div style={{ width: '100%', maxWidth: 420 }}>
                <div style={{ textAlign: 'center', marginBottom: 20 }}>
                    <Title level={3} style={{ marginBottom: 8 }}>
                        Download TV Panel
                    </Title>
                    <Text type="secondary">
                        Download TV Panel to access all portals.
                    </Text>
                </div>
                <TVPanelCard
                    storeContentVideoDetailsData={storeContentVideoDetailsData}
                />
            </div>
        </div>
    );
};

export default TVPanelBlock;
